import { render } from "./detailsIntroduction.vue?vue&type=template&id=430a2029"
import script from "./detailsIntroduction.vue?vue&type=script&lang=js"
export * from "./detailsIntroduction.vue?vue&type=script&lang=js"

import "./detailsIntroduction.vue?vue&type=style&index=0&id=430a2029&lang=css"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__